import React, { SVGProps } from 'react';

export const IconChevronUp = (props: SVGProps<SVGSVGElement>) => <svg fill="none" viewBox="0 0 32 32" width="1em" height="1em" {...props}><path fill="currentColor" d="m27.35 23.65 2.3-2.3a.5.5 0 0 0 0-.7l-13.3-13.3a.5.5 0 0 0-.7 0l-13.3 13.3a.5.5 0 0 0 0 .7l2.3 2.3c.2.2.5.2.7 0l10.3-10.3c.2-.2.5-.2.7 0l10.3 10.3c.2.2.5.2.7 0Z"/></svg>;
